export default __webpack_public_path__ + "8d8adf832cf2d5c617aabcef376ea280.svg";